import React from 'react';
import styles from './styles.module.scss';

export type BadgeTone = 'grass' | 'azure' | 'orange' | 'olive' | 'red' | 'muted';
/** `outlined` — full-strength tone (tables); `soft` — muted tone for dense card lists. */
export type BadgeVariant = 'outlined' | 'soft';

export interface BadgeProps {
  tone: BadgeTone;
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  testId?: string;
}

/**
 * Outlined uppercase badge with a leading dot in the tone colour; the label
 * stays neutral. Tone maps for roles / statuses live in `./tones`.
 */
export const Badge: React.FC<BadgeProps> = ({ tone, variant = 'outlined', children, className, testId }) => (
  <span
    className={[styles.badge, styles[tone], variant === 'soft' && styles.soft, className].filter(Boolean).join(' ')}
    data-testid={testId}
  >
    <span className={styles.label}>{children}</span>
  </span>
);

export default Badge;
